<astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1" alignItems="end">
  <astral-toggle [control]="form.controls['enabled']"></astral-toggle>
  <astral-select [control]="form.controls['imdMeterId']" [itemsSource]="meterSelection"></astral-select>
  @if (form.controls['imdMeterId'].value) {
    <astral-select
      [control]="form.controls['imdMeterModelId']"
      [itemsSource]="modelSelection"
    ></astral-select>
  }
  @if (allowNewMeter) {
    <div class="astral-form-adjacent-action">
      <astral-button
        variant="primary"
        size="small"
        icon="plus"
        labelKey="CONSUMPTION.METER.ADD"
        type="button"
        (click)="createMeter()"
      ></astral-button>
    </div>
  }
</astral-layout-group>

@if (showConsumption) {
  <div class="astral-stack-m">
    <app-period-consumption [meterId]="form.controls['imdMeterId'].value" [meterType]="meterType"></app-period-consumption>
  </div>
}
